import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { HookdeckVerification } from "../auth/hookdeck-middleware";
import { TooManyRequests } from "../error/http-api-errors";
import { WebhookSuccessResponse } from "../models/webhook";

/**
 * Webhook endpoint group
 *
 * This group handles incoming webhooks from various external services.
 * Webhooks are unauthenticated endpoints (no Authorization middleware)
 * and rely on service-specific verification mechanisms (e.g., signature validation).
 *
 * Design principles:
 * - Each webhook type gets its own endpoint
 * - All endpoints return WebhookSuccessResponse for successful processing
 * - Non-retriable errors return 200 OK to prevent retries
 * - Transient errors return appropriate status codes to trigger retries:
 *   - 429 TooManyRequests for rate limiting
 *   - 503 ServiceUnavailable for temporary service issues
 * - Service-specific verification happens in the handler layer
 */
export const WebhookGroup = HttpApiGroup.make("webhook")
  .add(
    HttpApiEndpoint.post("gmail", "/webhooks/gmail")
      .middleware(HookdeckVerification)
      .addSuccess(WebhookSuccessResponse)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.Unauthorized)
      .addError(TooManyRequests)
      .addError(HttpApiError.ServiceUnavailable),
  )
  .prefix("/api");
